import React from 'react'
import { Faqs, MainSection, Testimonial, WhoWe } from '../../components'


const HomePage = () => {
  return (
    <div className='m-top-130'>
        <MainSection />
        {/* <GallaryComponent /> */}
        {/* <LeadingCompanies /> */}
        <WhoWe/>
        <Faqs />
        <Testimonial />
    </div>
  )
}

export {HomePage}